module.exports = __webpack_public_path__ + "img/grand-vitara-imperial-grey.144e2be4.png";